import { createModel } from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";
import type { ProvisionStatusType } from "~~/package/apis/assessment/response/ProvisionStatusResponse";

export class LanguageProvisionStatusModel extends Model {
    constructor(
        public langType: string = '',
        public runningTasks: number = 0,
        public queueDepth: number = 0,
        public status: ProvisionStatusType = 'READY'
    ) {
        super();
    }

    public static create(model: Partial<LanguageProvisionStatusModel>): LanguageProvisionStatusModel {
        return createModel<LanguageProvisionStatusModel>(LanguageProvisionStatusModel, {
            ...model
        });
    }
}

export class ProvisionStatusModel extends Model {
    constructor(
        public status: ProvisionStatusType = 'READY',
        public languages: LanguageProvisionStatusModel[] = [],
        public estimatedWaitSeconds: number = 0
    ) {
        super();
    }

    public static create(model: Partial<ProvisionStatusModel>): ProvisionStatusModel {
        return createModel<ProvisionStatusModel>(ProvisionStatusModel, {
            ...model,
            languages: (model.languages ?? []).map((language) => LanguageProvisionStatusModel.create(language))
        });
    }
}
